import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { failed: boolean };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Application render error", error, info);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="fatal-error">
        <img src="/brand/phuoc-hao-horizontal.png" alt="Phước Hào" />
        <h1>Ứng dụng cần tải lại</h1>
        <p>
          Phiên làm việc của bạn vẫn được lưu. Hãy tải lại để tiếp tục công
          việc.
        </p>
        <button className="primary" onClick={() => window.location.reload()}>
          TẢI LẠI ỨNG DỤNG
        </button>
      </main>
    );
  }
}
